import React, { ChangeEventHandler } from 'react';

import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, TextField } from '@mui/material';

interface SearchInputProps {
  searchFilter: string;
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  placeholder?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  searchFilter,
  onChange,
  placeholder = 'Search by name or policy ID',
}) => {
  return (
    <TextField
      sx={{
        minWidth: '256px',
        width: '256px',
        '& .MuiOutlinedInput-root': {
          padding: 0,
          height: '32px',
          display: 'flex',
          alignItems: 'center',
        },
        '& .MuiOutlinedInput-input': {
          fontSize: '14.75px',
          height: '100%',
          boxSizing: 'border-box',
          '&::placeholder': {
            color: '#7E8590',
            opacity: 1,
          },
        },
      }}
      placeholder={placeholder}
      slotProps={{
        input: {
          'aria-label': 'Search input',
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ width: '16px', height: '16px', ml: '12px' }} />
            </InputAdornment>
          ),
        },
      }}
      onChange={onChange}
      value={searchFilter}
    />
  );
};

export default SearchInput;
